import { useMemo } from 'react';

const getLastPageIndex = (total: number, pageSize: number) => {
  return Math.floor((total + pageSize - 1) / pageSize) - 1;
};

export const usePaginationItems = (total: number, maxItems: number, page: number, pageSize: number): number[] => {
  const options: number[] = [];
  const pivot = Math.ceil(maxItems / 2);
  const lastPageIndex = useMemo(() => getLastPageIndex(total, pageSize), [pageSize, total]);

  if (lastPageIndex <= maxItems) {
    while (options.length <= lastPageIndex) {
      options.push(options.length + 1);
    }
  } else if (page < pivot) {
    while (options.length < maxItems) {
      options.push(options.length + 1);
    }
  } else if (page > lastPageIndex - pivot) {
    while (options.length < maxItems) {
      options.unshift(lastPageIndex - options.length + 1);
    }
  } else {
    for (let i = page - (pivot - 1); options.length < maxItems; i++) {
      options.push(i + 1);
    }
  }

  return options;
};
